module.exports = __webpack_public_path__ + "static/img/10020 (4).afb12fb.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/10000/10020 (4).webp
// module id = FnYE
// module chunks = 14